/**
 * Адрес, который человек уже ввёл на регистрации, — для подстановки в форму
 * входа, когда почта оказалась занята.
 *
 * Передаём его состоянием перехода (navigate state), а здесь держим дубль в
 * sessionStorage: в адресной строке почте не место, а состояние перехода
 * теряется при перезагрузке страницы. Живёт до закрытия вкладки и читается
 * ровно один раз.
 */
const KEY = 'astrofil_login_prefill_email';

export function rememberLoginEmail(email) {
  const value = (email || '').trim();
  if (!value) return;
  try {
    sessionStorage.setItem(KEY, value);
  } catch (e) {
    console.warn('Не удалось запомнить адрес для формы входа:', e);
  }
}

/** Забирает запомненный адрес и сразу его стирает. '' — если ничего нет. */
export function takeLoginEmail() {
  try {
    const value = sessionStorage.getItem(KEY);
    if (value) sessionStorage.removeItem(KEY);
    return value || '';
  } catch (e) {
    return '';
  }
}
